import { Component, HostListener, OnInit } from '@angular/core';
import { Helper } from './shared/Helper';
import { Router } from '@angular/router';
import { LoginService } from './service/login.service';
import { CampanhaService } from 'src/app/service/campanha.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public emManutencao: boolean = false;
  private desktopDataSourceSlider: string[] = [];
  private mobileDataSourceSlider: string[] = [];
  public _dataSourceSlider: string[] = [];
  public isMobile = false;

  public get showSlider(): boolean{
    return Helper.showSlider;
  }

  public sliderLinks;

  constructor(private router: Router, public loginService: LoginService, private campanhaService: CampanhaService) {

  }
  ngOnInit() {
    this.updateDeviceMode();
    this.LoadSlider();
  }

  public galeryClick(it)
  {
    if (this.sliderLinks)
    {
      if (this.sliderLinks.length >= (it.itemIndex + 1))
      {
        var url = this.sliderLinks[it.itemIndex];
        if (url)
        {
          window.open(url, "_blank");
        }
      }
    }
  }

  public get dataSourceSlider(): string[]{
    return this._dataSourceSlider;
  }

  public get VisualizaPromocao(): string{
    return Helper.getVisualizaPromocao();
  }

  public Sair() {
    localStorage.removeItem("jwt");
    this.loginService.Logado = false;
    this.router.navigate(['/login']);
  }

  public LoadSlider() {
    this.campanhaService.GetSlider().subscribe(sl => {
      const dataSourceDesktop: string[] = [];
      const dataSourceMobile: string[] = [];
      const sliderLinks: Array<string | null> = [];

      if (sl) {
        sl.forEach(s => {
          const sliderBasePath = Helper.basePathContent + 'carrossel/' + s.itemCarrosselId + '/';

          dataSourceDesktop.push(sliderBasePath + 'slider.jpg');
          dataSourceMobile.push(sliderBasePath + 'slidermobile.jpg');
          sliderLinks.push(s.url);
        });
      }

      this.desktopDataSourceSlider = dataSourceDesktop;
      this.mobileDataSourceSlider = dataSourceMobile;
      this.applyBannerByDevice();
      this.sliderLinks = sliderLinks;
      Helper.RefreshSlider();
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.updateDeviceMode();
    this.applyBannerByDevice();
  }

  private updateDeviceMode() {
    this.isMobile = window.innerWidth <= 991;
  }

  private applyBannerByDevice() {
    this._dataSourceSlider = this.isMobile
      ? this.mobileDataSourceSlider.slice()
      : this.desktopDataSourceSlider.slice();
  }
}
